import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { messagesApi } from '../../../../utils'
import { ObjectTypeNamesEnum } from '../../../../models/ObjectTypeEnum'
import classes from './CommunicationStudent.module.css';
import { throwApiError } from "../../../lms-shared/store/error-handling-actions";
import * as SubmissionStatus from "../../../lms-shared/models/SubmissionStatus";
import Chat from "../../../lms-shared/UI/Chat";
import { onKeyDown } from "../../../lms-shared/service";
import { cretaeMessageContent } from "../../../lms-shared/functions/Message";

const CommunicationStudent = ({ submissionDetails, nextAssessment, markAssessmentAsChecked }) => {
    const { lang, texts, direction } = useSelector(state => state.translate);
    const [newMessage, setNewMessage] = useState()
    const [communicationStudent, setCommunicationStudent] = useState()
    const [show, setShow] = useState(true);
    const { user } = useSelector(state => state.auth);
    let { id } = useParams();
    const { submissionId } = useParams()
    const dispatch = useDispatch()

    async function getData() {
        const data = {
            refObjectId: submissionId,
            refObjectType: ObjectTypeNamesEnum.Submission,
        }
        messagesApi.messagesFilterRangePost({ messagesRangeFilter: data }, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.MessageContentMessagesFilterRange, error: error, statusCode: response?.statusCode, message: "messagesFilterRangePost " + error.message, level: 2, component: "CommunicationStudent", line: 31 }))
            } else {
                // sort by date
                resdata.sort((a, b) => new Date(a.sentDate) - new Date(b.sentDate))
                setCommunicationStudent(
                    resdata.map(m => {
                        m.contents = m.contents?.length > 0 && JSON.parse(m.contents[0].content);
                        return m;
                    })
                )
                setToRead(resdata)
            }
        })
    }

    useEffect(() => {
        getData();
    }, [submissionId])

    function setToRead(messages) {
        if (messages.length > 0) {
            let messagesIds = []
            messages.forEach(m => {
                if (m.sourceObjectId !== user.id && !m.isRead) {
                    messagesIds.push(m.id)
                    m.isRead = true
                }
            });
            if (messagesIds.length > 0) {
                const data = {
                    messagesIds: messagesIds
                }
                messagesApi.messagesSetReadRangePost({ messageSetReadRangeInput: data }, (error, resdata, response) => {
                    if (error) {
                        dispatch(throwApiError({ userMessage: texts.MessageContentMessagesSetReadRange, error: error, statusCode: response?.statusCode, message: "messagesSetReadRangePost " + error.message, level: 1, component: "CommunicationStudent", line: 61 }))
                    }
                })
            }
        }
    }

    function sendMessage() {
        setNewMessage("")
        let newMessageEnter = newMessage.replaceAll('\n', '\\\\n')
        let contentString = `{"${lang}": "{ \\"text\\": \\"${newMessageEnter}\\" }"}`
        let content = JSON.parse(contentString)
        const data = {
            refObjectId: submissionId,
            refObjectType: ObjectTypeNamesEnum.Submission,
            contents: content
        }
        messagesApi.messagesAddPost({ messageAddOrUpdateInput: data }, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.MessagePostError, error: error, statusCode: response?.statusCode, message: "messagesAddPost " + error.message, level: 2, component: "CommunicationStudent", line: 86 }))
            } else {
                markAssessmentAsChecked(submissionDetails.id);
                getData()

                const textHe = `${texts.communicationStudentNewMesageHe}${user.firstName} ${user.lastName} ${newMessage.length > 14 ? newMessage + "..." : newMessage}`
                const textAr = `${texts.communicationStudentNewMesageAr}${user.firstName} ${user.lastName} ${newMessage.length > 14 ? newMessage + "..." : newMessage}`
                const textEn = `${texts.communicationStudentNewMesageEn}${user.firstName} ${user.lastName} ${newMessage.length > 14 ? newMessage + "..." : newMessage}`
                const link = `${id}/lesson/${submissionDetails?.lessonId}`;
                const content = cretaeMessageContent(textHe, textAr, textEn, link);
                const messageAddOrUpdateInput = {
                    refObjectId: id,
                    refObjectType: ObjectTypeNamesEnum.StudyGroup,
                    targetObjectId: submissionDetails?.submittedByUserId,
                    targetObjectType: ObjectTypeNamesEnum.User,
                    contents: content
                }
                messagesApi.messagesAddPost({ messageAddOrUpdateInput }, (error, resdata, response) => {
                    if (error) {
                        dispatch(throwApiError({ userMessage: texts.MessagePostError, error: error, statusCode: response?.statusCode, message: "messagesAddPost " + error.message, level: 1, component: "CommunicationStudent", line: 107 }))
                    }
                })
            }
        })
    }

    return (
        <>
            {show ?
                <div className={show ? classes.ShowCommunicationStudent : ''} >
                    {/* <div className={classes.CommunicationWithStudentContainer}></div> */}
                    <div className={classes.Title}>{texts.communicationWithStudent}</div>
                    <Chat
                        submissionDetails={submissionDetails}
                        sendMessage={sendMessage}
                        dropClass={`${classes.CommunicationStudentWrapper} ${(submissionDetails.submissionStatusId == SubmissionStatus.notStarted || submissionDetails.submissionStatusId == SubmissionStatus.started) ? classes.CommunicationWithBtn : ''}`}
                        communication={communicationStudent}
                        newMessage={newMessage}
                        setNewMessage={setNewMessage} >
                    </Chat>
                    <div className={classes.ArrowBtn} onClick={() => setShow(show => !show)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => setShow(show => !show))}>&#x203A;</div>
                    {nextAssessment ?
                        (submissionDetails.submissionStatusId == SubmissionStatus.notStarted || submissionDetails.submissionStatusId == SubmissionStatus.started) ?
                            <button className={classes.SubmitBtn} onClick={nextAssessment}>{texts.nextAssessment}</button>
                            : ''
                        : ''
                    }
                </div>
                :
                <div className={classes.CommunicationStudentContainerResponsive} onClick={() => setShow(show => !show)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => setShow(show => !show))}>
                    &#x2039;&#x2039;
                </div>
            }
        </>
    )
}

export default CommunicationStudent;